import { DAIMI_EN_INTRO, DAIMI_EN_SLUG } from '@/content/daimiEnergy'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The thirty-first report with a designed page of its own, and the sixteenth focus
  // cut to arrive with both of its figures — asked for on 2026-08-28 in the same words
  // as the Insurance, Logistics and Manufacturing cuts before it (*"referans alarak
  // ilgili sayfayı birebir tıpa tıp aynısını tasarla"*) with a four-part full-page
  // capture of the live page, the cover as two overlapping 2000px crops, Figure 1 and
  // the report mockup. See `content/daimiEnergy.ts` and `pages/DaimiEnergy.tsx`. Not to
  // be confused with the Future 2030 Energy & Utilities outlook further down, which is
  // a separate report on `'energy-outlook'`, nor with the Utilities focus cut, which is
  // a third report again on `'utilities-focus'`.
  ...focus(
    DAIMI_EN_SLUG,
    'Energy',
    'daimi-report-2026-energy-cover',
    'ed58b3ac-01fb-4c52-9d08-12898883a67b-digitopia-daimi-2026-report-energy.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference capture and held on
  // the page that says them — so the search result and the page cannot drift apart.
  // `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_EN_INTRO.body,
  layout: 'energy-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section on
  // its page, and `daimiEnergyChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 9
